import withHandlePhoneLinkClick from 'components/common/hoc/withHandlePhoneLinkClick'
import Location from './Location'

export default withHandlePhoneLinkClick(Location)
